import { createSWStoreWithShapeNodeMap } from "./createSWStoreWithShapeNodeMap";
import { LoadableMap } from "./loadables";
import { NodeMap } from "./nodes";
import { SWPaywallRecordType, createPaywallId } from "./records";
// import { createSWStore } from "../../editor/lib/config/createSWStore"
// import { defaultNodeUtils } from "../../lib/nodes"
export const createEmptyStore = (options = {})=>{
    const store = createSWStoreWithShapeNodeMap({
        ...options,
        defaultName: "Untitled",
        loadableTypeMap: LoadableMap,
        nodeTypeMap: NodeMap
    });
    return store;
};
export const createBlankStore = ()=>{
    const paywallId = createPaywallId("paywall");
    return createEmptyStore({
        initialData: {
            [paywallId]: SWPaywallRecordType.create({
                id: paywallId,
                version: 0,
                editable: true
            })
        }
    });
};
export const createBlankSnapshot = ()=>{
    return createBlankStore().getSnapshot();
};
